import { Button, Modal, Select, message, notification, InputNumber } from "antd";
import { useModalStore } from "@/hooks/useModalStore";
import { useEffect, useState } from "react";
import { CheckIcon } from "@/components/icons";
import { campaignUpdateBudgetApi } from "@/api/campaignList";
import { CampaignMarketingStrategy } from "@/pages/campaignCreate/components/DevelopStrategy/config";
import { useTranslation } from "react-i18next";

export default function ChangeBudgetModal() {
  const { t } = useTranslation();
  const [api, contextHolder] = notification.useNotification();
  const { 
    changeBudgetModalInfo, 
    setChangeBudgetModalInfo, 
    setShowChargeModal, 
    setChargeModalInfo,
    setPayPlace
  } = useModalStore();
  const [budget, setBudget] = useState<number>(
    changeBudgetModalInfo?.budget as number
  );

  useEffect(() => {
    setBudget(changeBudgetModalInfo.budget as number);
  }, [changeBudgetModalInfo.budget]);

  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    const params: {
      budgetLimitMonthly?: number;
      affiliateBudget?: number;
    } = {};
    if (changeBudgetModalInfo?.marketingStrategy === CampaignMarketingStrategy.INFLUENCER_MARKETING) {
      params.budgetLimitMonthly = budget;
    }
    if (changeBudgetModalInfo?.marketingStrategy === CampaignMarketingStrategy.AFFILIATES_MARKETING) {
      params.affiliateBudget = budget;
    }
    try {
      const res = await campaignUpdateBudgetApi(changeBudgetModalInfo?.campaignId, params);
      const { needTopup, needTopupAmount } = res || {};
      if (needTopup) {
        setShowChargeModal(true);
        setChargeModalInfo({
          amount: needTopupAmount,
        });
        setPayPlace("");
        return;
      }
      setChangeBudgetModalInfo({
        visible: false,
        campaignId: "",
        budget: null,
        marketingStrategy: CampaignMarketingStrategy.INFLUENCER_MARKETING,
      });
      api.open({
        message: (
          <div className="flex items-center">
            <CheckIcon className="w-6 h-6 mr-[8px] text-[#1E874C]" />
            <span className="text-[#17663A]">{t('components.modal.changeBudget.budgetUpdated')}</span>
          </div>
        ),
        description: "",
        closeIcon: false,
        className: "",
        style: {
          width: 320,
          height: 44,
          backgroundColor: "#EEFBF4",
          padding: "10px 20px",
          borderRadius: " 6px",
        },
      });
      window.location.reload();
    } catch (error) {
      message.error(`${error}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={changeBudgetModalInfo?.visible}
      onCancel={() => {
        setChangeBudgetModalInfo({
          visible: false,
          campaignId: "",
          budget: null,
          marketingStrategy: CampaignMarketingStrategy.INFLUENCER_MARKETING,
        });
      }}
      width={460}
      title={t('components.modal.changeBudget.title')}
      footer={null}
    >
      <>
        <div className="flex flex-col mt-4 gap-2">
          <InputNumber
            style={{ width: "344px" }}
            addonAfter="USD"
            controls={false}
            min={changeBudgetModalInfo?.budget as number}
            value={budget}
            onChange={(e) => {
              setBudget(e as number);
            }}
            size="large"
          />
          <div className="justify-start">
            <span className="text-[#A3A3A3] text-sm font-medium  leading-snug">
              {t('components.modal.changeBudget.assistanceText')}{" "}
            </span>
            <a
              href="mailto:support@aha.inc"
              className="text-[#2B7FFF] text-sm font-medium leading-snug"
            >
              {t('components.modal.changeBudget.contactUs')}
            </a>
          </div>
        </div>
        <Button
          type="primary"
          size="large"
          className="w-full mt-8"
          onClick={handleSubmit}
          loading={loading}
        >
          {t('components.modal.changeBudget.confirm')}
        </Button>
      </>
    </Modal>
  );
}
